import React from 'react';
//import AdminDropdown from '../../../adminDropdown';
//import { osloVerksteder } from '../../../../helpers/verksted-liste';
//import AdminVerkstedCard from '../../../adminVerkstedCard';
import useRetrieveKjedeVerksteder from '../../../../hooks/verksteder';
import Loader from '../../../loader';
import EgenAdminDropdown from '../../../egenAdminDropdown';
//import { getLocalStorageItem } from '../../../../helpers/storage';

function AdminNorge(){

    //const userInfo = getLocalStorageItem('user');


    const {verksteder, isLoading, isError } = useRetrieveKjedeVerksteder();

    // /me?populate=* kan gjøre at man finner kjedeID


    const getVerkstedTitle = (verksted) => {
        const country = verksted.attributes.address.country;
        const region = verksted.attributes.address.region;
    
        // Lag en unik nøkkel basert på country og region
        const key = `${country}_${region}`;
    
        // Returner den unike nøkkelen
        return key;
    };

// Filtrer ut verksteder som ikke er i Norge
    const norskeVerksteder = verksteder.filter(verksted => {
        const address = verksted.attributes.address;
        return address && address.country === 'Norge'
    });

// Grupper verksteder etter region
    const verkstederByLocation = norskeVerksteder.reduce((acc, verksted) => {
        const locationKey = getVerkstedTitle(verksted);
    
        if (!acc[locationKey]) {
            acc[locationKey] = [];
        }
    
        acc[locationKey].push(verksted);
        return acc;
    }, {});

    if(isLoading) {
        return(<div><Loader /></div>)
    }

    if(isError) {
        <p>Oida, noe gikk galt! Vennligst last inn siden på nytt</p>
    }

// Få en sortert rekkefølge av nøklene (regionene)
    const sortedRegions = Object.keys(verkstederByLocation).sort();

// Opprett dropdowns for hver region i sortert rekkefølge
    return (
        <div>
            {sortedRegions.map((regionKey, index) => {
                const [country, region] = regionKey.split('_');
                console.log(country);
                return (
                    <div key={index}>
                        <EgenAdminDropdown
                            title={region}
                            verksteder={verkstederByLocation[regionKey]}
                        />
                    </div>
                );
            })}
        </div>
    );

    
}

export default AdminNorge;




// const [kundeID, setKundeID] = useState(null);
    // const [verksteder, setVerksteder] = useState([]);
    // const [isLoading, setIsLoading] = useState(true);
    // const [isError, setIsError] = useState(false);

    // useEffect(() => {
    //     if (userInfo) {
    //         const adminMail = userInfo.user.email.toLowerCase();
    //         let kundeIDToUse = 1; // Default kundeID

    //         if(adminMail.endsWith('@intakt.no')) {
    //             kundeIDToUse = 2; // Bruk kundeID for intakt.no
    //         } else if (adminMail.endsWith('@tesla.no')) {
    //             kundeIDToUse = 3; // Bruk kundeID for tesla.no
    //         } else if(adminMail.endsWith('@volvo.no')) {
    //             kundeIDToUse = 4;
    //         }
            
    //         // setKundeID(kundeIDToUse);

    //         useRetrieveKjedeVerksteder(kundeIDToUse)
    //             .then((data) => {
    //                 setVerksteder(data);
    //                 setIsLoading(false);
    //             })
    //             .catch((error) => {
    //                 setIsError(true);
    //                 setIsLoading(false);
    //             });
    //     }
    // }, [userInfo]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (userInfo) {
    //             const adminMail = userInfo.user.email.toLowerCase();
    //             let kundeIDToUse = 1; // Default kundeID

    //             if (adminMail.endsWith('@intakt.no')) {
    //                 kundeIDToUse = 2; // Bruk kundeID for intakt.no
    //             } else if (adminMail.endsWith('@tesla.no')) {
    //                 kundeIDToUse = 3; // Bruk kundeID for tesla.no
    //             }

    //             try {
    //                 const data = await useRetrieveKjedeVerksteder(kundeIDToUse);
    //                 setVerksteder(data);
    //                 setIsLoading(false);
    //             } catch (error) {
    //                 setIsError(true);
    //                 setIsLoading(false);
    //             }
    //         }
    //     };

    //     fetchData();
    // }, [userInfo]);

    // const { verksteder, isLoading, isError } = useRetrieveKjedeVerksteder(kundeID);












// const {verksteder, isLoading, isError } = useRetrieveKjedeVerksteder(1);

    // console.log(verksteder);

    // const getVerkstedTitle = (verksted) => {
    //     const country = verksted.attributes.address.country;
    //     const region = verksted.attributes.address.region;
      
    //     // Lag en unik nøkkel basert på country og region
    //     const key = `${country}_${region}`;
      
    //     // Returner den unike nøkkelen
    //     return key;
    //   };
      
    //   const verkstederByLocation = verksteder.reduce((acc, verksted) => {
    //     const locationKey = getVerkstedTitle(verksted);
      
    //     if (!acc[locationKey]) {
    //       acc[locationKey] = [];
    //     }
      
    //     acc[locationKey].push(verksted);
    //     return acc;
    //   }, {});

    //    console.log(verkstederByLocation);

    //   const norwayVerksteder = Object.keys(verkstederByLocation)
    //     .filter((locationKey) => locationKey.startsWith("Norge_"))
    //     .map((locationKey) => verkstederByLocation[locationKey])
    //     .flat();

    //   console.log(norwayVerksteder);

    //   const swedenVerksteder = Object.keys(verkstederByLocation)
    //     .filter((locationKey) => locationKey.startsWith("Sverige_"))
    //     .map((locationKey) => verkstederByLocation[locationKey])
    //     .flat();

    //   console.log(swedenVerksteder);

    // if(isLoading) {
    //     return(<div><Loader /></div>)
    // }

    // if(isError) {
    //     <p>Oida, noe gikk galt! Vennligst last inn siden på nytt</p>
    // }
    
    // return (
        
    //     <div>
    //         {Object.keys(verkstederByLocation).map((locationKey, index) => {
    //         const [country, region] = locationKey.split('_'); // Splitter nøkkelen
    //         console.log(country);
    //         return (
    //             <div key={index}>
    //             <AdminDropdown
    //                 title={region}
    //                 body={
    //                 <ul>
    //                     {verkstederByLocation[locationKey].map((verksted, innerIndex) => (
    //                     <AdminVerkstedCard
    //                         key={innerIndex}
    //                         title={verksted.attributes.username}
    //                         image={verksted.image}
    //                         className="admin-verksted-card m-auto"
    //                     />
    //                     ))}
    //                 </ul>
    //                 }
    //             />
    //             </div>
    //         );
    //         })}
    //     </div>
    // )




// <div>
        //     <h1 className="mt-5">NORGE</h1>
        //     <div className='col-xl-12 m-auto'>
        //         <AdminDropdown 
        //         title="AGDER"
        //         body={
        //             <ul>
        //               {osloVerksteder.map((verksted, index) => (
        //                     <AdminVerkstedCard
        //                     key={index}
        //                     title={verksted.name}
        //                     image={verksted.image}
        //                     className="admin-verksted-card m-auto" 
        //                     />
        //                 ))}
        //             </ul>
        //           }
        //         />
        //         <AdminDropdown 
        //         title="INNLAND"
        //         body={
        //             <ul>
        //               {osloVerksteder.map((verksted, index) => (
        //                     <AdminVerkstedCard
        //                     key={index}
        //                     title={verksted.name}
        //                     image={verksted.image}
        //                     className="admin-verksted-card m-auto" 
        //                     />
        //                 ))}
        //             </ul>
        //           }
        //         />
        //         <AdminDropdown 
        //         title="OSLO"
        //         body={
        //             <ul>
        //               {osloVerksteder.map((verksted, index) => (
        //                     <AdminVerkstedCard
        //                     key={index}
        //                     title={verksted.name}
        //                     image={verksted.image}
        //                     className="admin-verksted-card m-auto" 
        //                     />
        //                 ))}
        //             </ul>
        //           }
        //         />
        //         <AdminDropdown 
        //         title="VESTLAND"
        //         body={
        //             <ul>
        //               {osloVerksteder.map((verksted, index) => (
        //                     <AdminVerkstedCard
        //                     key={index}
        //                     title={verksted.name}
        //                     image={verksted.image}
        //                     className="admin-verksted-card m-auto" 
        //                     />
        //                 ))}
        //             </ul>
        //           }
        //         />
        //         <AdminDropdown 
        //         title="VIKEN"
        //         body={
        //             <ul>
        //               {osloVerksteder.map((verksted, index) => (
        //                     <AdminVerkstedCard
        //                     key={index}
        //                     title={verksted.name}
        //                     image={verksted.image}
        //                     className="admin-verksted-card m-auto"
        //                     />
        //                 ))}
        //             </ul>
        //           }
        //         />
        //     </div>
        // </div>